export interface ModuleField {
  field: string
  fieldName: string
  filterEmpty?: boolean
}

export interface IntegrationModule {
  id: string
  name: string
  endpoint: string
  createEndpoint?: string
  fields: ModuleField[]
  tenantType?: 'fashion' | 'aco'
  responseKey?: string
  paginationType?: 'offset' | 'page' | 'skip-take'
}

export const integrationModules: IntegrationModule[] = [
  {
    id: 'companies',
    name: 'Empresas',
    endpoint: '/companies/companies',
    createEndpoint: '/companies/companies',
    fields: [
      { field: 'id', fieldName: 'ID' },
      { field: 'companyName', fieldName: 'Razão Social' },
      { field: 'cnpj', fieldName: 'CNPJ' },
      { field: 'cpf', fieldName: 'CPF' },
      { field: 'stateRegistration', fieldName: 'Inscrição Estadual' },
      { field: 'phone', fieldName: 'Telefone' },
      { field: 'email', fieldName: 'E-mail' },
      { field: 'companyTypes', fieldName: 'Tipo de Empresa', filterEmpty: true },
      { field: 'cep', fieldName: 'CEP' },
      { field: 'street', fieldName: 'Rua' },
      { field: 'number', fieldName: 'Número' },
      { field: 'complement', fieldName: 'Complemento' },
      { field: 'neighborhood.name', fieldName: 'Bairro' },
      { field: 'City.name', fieldName: 'Cidade' },
      { field: 'State.name', fieldName: 'Estado' },
    ]
  },
  {
    id: 'equipment',
    name: 'Equipamentos',
    endpoint: '/equipment/equipment',
    createEndpoint: '/equipment/equipment',
    fields: [
      { field: 'id', fieldName: 'ID' },
      { field: 'code', fieldName: 'Código' },
      { field: 'name', fieldName: 'Nome' },
      { field: 'model', fieldName: 'Modelo' },
      { field: 'manufacturer', fieldName: 'Fabricante' },
      { field: 'year', fieldName: 'Ano' },
      { field: 'dimension', fieldName: 'Dimensão' },
      { field: 'weight', fieldName: 'Peso' },
      { field: 'costPerHour', fieldName: 'Custo por Hora' },
      { field: 'capacity', fieldName: 'Capacidade' },
    ]
  },
  {
    id: 'vehicles',
    name: 'Veículos',
    endpoint: '/equipment/vehicles',
    createEndpoint: '/equipment/vehicles',
    fields: [
      { field: 'id', fieldName: 'ID' },
      { field: 'plate', fieldName: 'Placa' },
      { field: 'model', fieldName: 'Modelo' },
      { field: 'year', fieldName: 'Ano' },
      { field: 'capacity', fieldName: 'Capacidade' },
      { field: 'restriction', fieldName: 'Restrição' },
      { field: 'bodyType', fieldName: 'Tipo de Carroceria' },
    ]
  },
  {
    id: 'resources',
    name: 'Insumos',
    responseKey: 'data',
    paginationType: 'skip-take',
    endpoint: '/resources/resource',
    createEndpoint: '/resources/resource',
    fields: [
      { field: 'id', fieldName: 'ID' },
      { field: 'name', fieldName: 'Nome' },
      { field: 'code', fieldName: 'Código' },
      { field: 'description', fieldName: 'Descrição' },
      { field: 'category.name', fieldName: 'Categoria' },
      { field: 'type.name', fieldName: 'Tipo' },
      { field: 'material', fieldName: 'Material' },
      { field: 'format', fieldName: 'Formato' },
      { field: 'fabrication', fieldName: 'Fabricação' },
      { field: 'ncm', fieldName: 'NCM' },
      { field: 'shelf', fieldName: 'Prateleira' },
      { field: 'stockLocation', fieldName: 'Localização de Estoque' },
      { field: 'stockUnit', fieldName: 'Unidade de Estoque' },
      { field: 'unitQuantity', fieldName: 'Qtd. por Unidade' },
      { field: 'totalWeight', fieldName: 'Peso Total' },
      { field: 'lengthInMm', fieldName: 'Comprimento (mm)' },
      { field: 'dimension1', fieldName: 'Dimensão 1' },
      { field: 'dimension2', fieldName: 'Dimensão 2' },
      { field: 'suppliers', fieldName: 'Fornecedores', filterEmpty: true },
      { field: 'colors', fieldName: 'Cores', filterEmpty: true },
    ]
  },
  {
    id: 'services',
    name: 'Serviços',
    endpoint: '/services/service-stage',
    fields: [
      { field: 'id', fieldName: 'ID' },
      { field: 'name', fieldName: 'Nome' },
      { field: 'description', fieldName: 'Descrição' },
      { field: 'Category_Stage.name', fieldName: 'Categoria' },
      { field: 'Type_Category_Stage.name', fieldName: 'Tipo' },
      { field: 'machines', fieldName: 'Máquinas', filterEmpty: true },
      { field: 'suppliers', fieldName: 'Fornecedores', filterEmpty: true },
    ]
  },
  {
    id: 'production',
    name: 'Produção',
    paginationType: 'skip-take',
    endpoint: '/production-flow/service',
    fields: [
      { field: 'id', fieldName: 'ID' },
      { field: 'codeOfOP', fieldName: 'Código da OP' },
      { field: 'status', fieldName: 'Status' },
    ]
  },
  {
    id: 'fashion-stock',
    name: 'Estoque',
    tenantType: 'fashion',
    endpoint: '/backend-fashion-orders/fashion-product/stocks',
    fields: [
      { field: 'id', fieldName: 'ID' },
      { field: 'description', fieldName: 'Descrição' },
      { field: 'material', fieldName: 'Material' },
      { field: 'format', fieldName: 'Formato' },
      { field: 'finishing', fieldName: 'Acabamento' },
      { field: 'heatTreatment', fieldName: 'Tratamento Térmico' },
      { field: 'supplier', fieldName: 'Fornecedor' },
      { field: 'StockColors', fieldName: 'Cores', filterEmpty: true },
      { field: 'color', fieldName: 'Cor', filterEmpty: true },
      { field: 'measurementUnit', fieldName: 'Unidade' },
      { field: 'quantity', fieldName: 'Quantidade' },
      { field: 'availableBalance', fieldName: 'Saldo Disponível' },
      { field: 'totalWeight', fieldName: 'Peso Total' },
      { field: 'dimension1', fieldName: 'Dimensão 1' },
      { field: 'dimension2', fieldName: 'Dimensão 2' },
      { field: 'costPerKg', fieldName: 'Custo/Kg' },
      { field: 'totalCost', fieldName: 'Custo Total' },
      { field: 'family', fieldName: 'Família' },
      { field: 'characteristic', fieldName: 'Característica' },
      { field: 'status', fieldName: 'Status' },
      { field: 'nf', fieldName: 'NF' },
      { field: 'purchaseOrder', fieldName: 'Pedido de Compra' },
      { field: 'receivedDate', fieldName: 'Data de Recebimento' },
    ]
  },
  {
    id: 'steel-stock',
    name: 'Estoque',
    tenantType: 'aco',
    paginationType: 'skip-take',
    endpoint: '/backend/stock/integration',
    fields: [
      { field: 'id', fieldName: 'ID' },
      { field: 'material', fieldName: 'Material' },
      { field: 'format', fieldName: 'Formato' },
      { field: 'finishing', fieldName: 'Acabamento' },
      { field: 'heatTreatment', fieldName: 'Tratamento Térmico' },
      { field: 'measurementUnit', fieldName: 'Unidade' },
      { field: 'quantity', fieldName: 'Quantidade' },
      { field: 'availableBalance', fieldName: 'Saldo Disponível' },
      { field: 'totalWeight', fieldName: 'Peso Total' },
      { field: 'dimension1', fieldName: 'Dimensão 1' },
      { field: 'dimension2', fieldName: 'Dimensão 2' },
      { field: 'costPerKg', fieldName: 'Custo/Kg' },
      { field: 'costPerMm', fieldName: 'Custo/mm' },
      { field: 'totalCost', fieldName: 'Custo Total' },
      { field: 'lengthInMm', fieldName: 'Comprimento (mm)' },
      { field: 'totalCmc', fieldName: 'CMC Total' },
      { field: 'runNumber', fieldName: 'Nº de Corrida' },
      { field: 'family', fieldName: 'Família' },
      { field: 'characteristic', fieldName: 'Característica' },
      { field: 'description', fieldName: 'Descrição' },
      { field: 'status', fieldName: 'Status' },
      { field: 'nf', fieldName: 'NF' },
      { field: 'certificateNumber', fieldName: 'Nº Certificado' },
      { field: 'purchaseOrder', fieldName: 'Pedido de Compra' },
      { field: 'receivedDate', fieldName: 'Data de Recebimento' },
      { field: 'trackingNumber', fieldName: 'Rastreamento' },
    ]
  },
  {
    id: 'fashion-collections',
    name: 'Coleções',
    tenantType: 'fashion',
    responseKey: 'content',
    endpoint: '/backend-fashion-orders/fashion-product/collections',
    fields: [
      { field: 'id', fieldName: 'ID' },
      { field: 'name', fieldName: 'Nome' },
      { field: 'Family', fieldName: 'Famílias', filterEmpty: true },
      { field: 'GroupInCollection', fieldName: 'Grupos', filterEmpty: true },
      { field: 'GradeInCollection', fieldName: 'Grades', filterEmpty: true },
      { field: 'CollectionColor', fieldName: 'Cores', filterEmpty: true },
      { field: 'CollectionMaterial', fieldName: 'Materiais', filterEmpty: true },
    ]
  },
  {
    id: 'fashion-families',
    name: 'Famílias',
    tenantType: 'fashion',
    responseKey: 'content',
    endpoint: '/backend-fashion-orders/fashion-product/families',
    fields: [
      { field: 'id', fieldName: 'ID' },
      { field: 'name', fieldName: 'Nome' },
      { field: 'Collection.name', fieldName: 'Coleção' },
      { field: 'GroupInFamily', fieldName: 'Grupos', filterEmpty: true },
      { field: 'GradeInFamily', fieldName: 'Grades', filterEmpty: true },
      { field: 'FamilyColor', fieldName: 'Cores', filterEmpty: true },
    ]
  },
  {
    id: 'fashion-products',
    name: 'Composição do Produto',
    tenantType: 'fashion',
    endpoint: '/backend-fashion-orders/fashion-product',
    fields: [
      { field: 'id', fieldName: 'ID' },
      { field: 'name', fieldName: 'Nome' },
      { field: 'productCode', fieldName: 'Código' },
      { field: 'norm', fieldName: 'Norma' },
      { field: 'price', fieldName: 'Preço' },
      { field: 'status', fieldName: 'Status' },
      { field: 'Group.name', fieldName: 'Grupo' },
      { field: 'Family.name', fieldName: 'Família' },
      { field: 'Collection.name', fieldName: 'Coleção' },
      { field: 'GradeInProduct', fieldName: 'Grades', filterEmpty: true },
      { field: 'ProductItemColor', fieldName: 'Cores', filterEmpty: true },
    ]
  },
  {
    id: 'fashion-orders',
    name: 'Pedidos Fashion',
    tenantType: 'fashion',
    paginationType: 'skip-take',
    endpoint: '/backend-fashion-orders/fashion-production-orders',
    fields: [
      { field: 'id', fieldName: 'ID' },
      { field: 'set', fieldName: 'Conjunto' },
      { field: 'orderId', fieldName: 'Pedido de Venda' },
      { field: 'status', fieldName: 'Status' },
      { field: 'priority', fieldName: 'Prioridade' },
      { field: 'productionDay', fieldName: 'Dia de Produção' },
      { field: 'fashionProduct.name', fieldName: 'Produto' },
      { field: 'fashionProduct.Collection.name', fieldName: 'Coleção' },
      { field: 'fashionProduct.Family.name', fieldName: 'Família' },
      { field: 'fashionProduct.Group.name', fieldName: 'Grupo' },
      { field: 'color.name', fieldName: 'Cor' },
      { field: 'machine.name', fieldName: 'Máquina' },
    ]
  },
]

export const integrationTypes = [
  { id: 'read', name: 'Leitura', description: 'Apenas consulta os dados existentes' },
  { id: 'write', name: 'Registro', description: 'Consulta e permite criar novos registros' },
]

export const getModuleById = (id: string): IntegrationModule | undefined => {
  return integrationModules.find(module => module.id === id)
}

export const getFieldsByModuleId = (moduleId: string): ModuleField[] => {
  const module = getModuleById(moduleId)
  return (module?.fields || []).filter(f => f.field !== 'id')
}
